module.exports = __webpack_public_path__ + "assets/webgl/Ceramic_materialParams.1001.jpg.astc.5e10e782.ktx";